import {useCallback, useEffect, useState} from "react";
import {DefaultDeliveryFlow} from "../../../util/types";
import {findMetadata, isPastDays} from "../../../util/helpers";
import TdcFbsaTimeline from "./Timeline/TdcFbsaTimeline";
import {getDeliveryFlow} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import StatusIndicator from "./StatusIndicator";
import OpennetTimeline from "./Timeline/OpennetTimeline";
import NotificationList from "./NotificationList";
import {ScrollToAnchorListener} from "../../../util/ScrollToAnchor";
import LoaderSpinner from "../../loaders/LoaderSpinner";

interface DeliveryFlowProps {
    id: number;
    withDivider?: boolean;
}

export default function DeliveryFlow({id, withDivider}: DeliveryFlowProps) {
    const {customer} = useCustomer();

    const [loading, setLoading] = useState<boolean>(true)
    const [deliveryFlow, setDeliveryFlow] = useState<DefaultDeliveryFlow | null>(null);
    const [isOpen, setIsOpen] = useState<boolean>(true)
    const [hideFlowStatus, setHideFlowStatus] = useState<boolean>(false)

    useEffect(() => {
        if (!deliveryFlow) {
            return;
        }

        const online_date = findMetadata("product_instance_status_active_date", deliveryFlow.timeline_metadata)

        if (online_date && isPastDays(online_date, 30)) {
            setIsOpen(false)
            setHideFlowStatus(true)
        }
    }, [deliveryFlow]);

    const fetchDeliveryFlow = useCallback(() => {
        return getDeliveryFlow(customer.customer_id, id)
            .then(r => setDeliveryFlow(r.response.data))
            .catch(() => {})
    }, [customer, id])

    useEffect(() => {
       fetchDeliveryFlow()
        .finally(() => setLoading(false))
    }, [fetchDeliveryFlow]);

    if (loading) {
        return <LoaderSpinner/>
    }

    if (!deliveryFlow) {
        return null;
    }

    return (
        <div className={`selfcare-delivery-flow-container${isOpen ? " open" : ""}`}>
            <div className="selfcare-delivery-flow-header">
                <p><strong>{ findMetadata("product_display_name", deliveryFlow.timeline_metadata)}</strong></p>

                <div className="toggle-delivery-flow" onClick={() => {setIsOpen(!isOpen)}}>
                    <span className="text">{isOpen ? "Luk" : "Åbn"} installationsforløb</span>
                    <span className={`arrow${isOpen ? " arrow-up" : " arrow-down"}`}></span>
                </div>
            </div>
            <section className="selfcare-delivery-flow">
                {!hideFlowStatus && <StatusIndicator deliveryFlow={deliveryFlow} requests={deliveryFlow.communication_requests}/>}

                {deliveryFlow.timeline_info.timeline_type === "tdc-fbsa" && <TdcFbsaTimeline deliveryFlow={deliveryFlow}/>}
                {deliveryFlow.timeline_info.timeline_type === "opennet" && <OpennetTimeline deliveryFlow={deliveryFlow}/>}


                <NotificationList requests={deliveryFlow.communication_requests} onUpdate={fetchDeliveryFlow}/>

                {withDivider && <hr/>}
            </section>
            <ScrollToAnchorListener />
        </div>
    )
}
